import React from 'react';
import { HourglassIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
function Unit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <span className="inline-flex items-baseline gap-1.5" data-id="element-103" data-mp="p1cahanup55m">
      <span className="font-display text-2xl font-black tabular-nums tracking-wide text-white sm:text-3xl" style={{
      fontFamily: 'Montserrat, sans-serif',
      fontSize: "20px"
    }} data-id="element-104" data-mp="p0srdqmgsaq0">
        {String(value).padStart(2, '0')}
      </span>
      <span className="text-[10px] font-bold uppercase tracking-widest text-grape-soft sm:text-xs" data-id="element-105" data-mp="k1zcbtrj4bnq">{label}</span>
    </span>;
}
export function OfferBar() {
  const {
    mm,
    ss
  } = useCountdown();
  return <div role="region" aria-label="Offer countdown" className="fixed inset-x-0 top-0 z-50 border-b-2 border-grape-soft bg-plum text-white shadow-[0_6px_20px_-10px_rgba(0,0,0,0.7)]" data-id="element-106" data-mp="abwmu3jm9fu5">
      <div className="mx-auto flex max-w-5xl items-center justify-between gap-4 px-4 py-3 sm:px-6" style={{
      paddingTop: "5px",
      paddingBottom: "6px",
      width: "374px",
      height: "40px",
      paddingRight: "35px"
    }} data-id="element-107" data-mp="1b84iwn6wtbg">
        <p className="flex items-center gap-2.5 text-[13px] font-extrabold uppercase leading-tight tracking-[0.18em] sm:text-base sm:tracking-[0.22em]" data-id="element-108" data-mp="my9mxqibf524">
          <HourglassIcon className="h-5 w-5 shrink-0 text-grape-soft" aria-hidden="true" style={{
          width: "17px",
          height: "19px"
        }} data-id="element-109" data-mp="10vf0ebkcz67e" />
          <span style={{
          fontSize: "8px"
        }} data-id="element-110" data-mp="88khhj36wew1">Offer expires in:</span>
        </p>

        <p className="flex shrink-0 items-baseline gap-1.5 sm:gap-2.5" data-id="element-111" data-mp="86hg62wl6zc0">
          <Unit value={mm} label="Min" data-id="element-112" data-mp="3bkc7ae5zg5z" />
          <span className="text-xl font-black text-grape-soft" data-id="element-113" data-mp="hydi5p1sn9li">:</span>
          <Unit value={ss} label="Sec" data-id="element-114" data-mp="i0qamw56h2ct" />
        </p>
      </div>
    </div>;
}